import React from 'react';

import { Step } from '~components/wizard-form/props';

import type { RollbackEstimateResponse, RollbackInvite } from '~support-at-home/actions/statements';

import Check from '../../components/claims/statements-rollback/Check';
import Criteria from '../../components/claims/statements-rollback/Criteria';
import Introduction from '../../components/claims/statements-rollback/Introduction';
import { ROLLBACK_ACKNOWLEDGEMENTS, ROLLBACK_POINTS } from './rollbackWarnings';

export { ROLLBACK_ACKNOWLEDGEMENTS, ROLLBACK_POINTS };

export type RollbackCheckValue = { data: RollbackEstimateResponse } | null;

// All or nothing: only when every statement the link covers can be rolled back
export const canRollBack = (check?: RollbackCheckValue) =>
  Boolean(check?.data?.can_roll_back) && (check?.data?.affected?.length ?? 0) > 0;

// TAV-3491: the steps are built per link. The month and clients come from the link and are read only.
export const buildRollbackSteps = (invite: RollbackInvite, token: string): Step[] => [
  {
    step: 1,
    title: 'Introduction',
    fields: {
      introduction: {
        type: 'custom',
        component: Introduction,
        colSize: 12,
      },
    },
  },
  {
    step: 2,
    title: 'Criteria',
    fields: {
      criteria: {
        type: 'custom',
        component: () => React.createElement(Criteria, { invite }),
        colSize: 12,
      },
    },
  },
  {
    step: 3,
    title: 'Check',
    fields: {
      rollback_check: {
        type: 'custom',
        component: (props: { onChange?: (name: string, value: any) => void }) =>
          React.createElement(Check, { ...props, token, invite }),
        colSize: 12,
      },
    },
    // No way forward unless every statement can be rolled back
    showNextButton: ({ values }) => canRollBack(values?.rollback_check as RollbackCheckValue),
  },
];
